import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { IRound, IRoundGame } from 'types/Round';

// Define a type for the slice state
interface RoundState {
  round: IRoundGame | null;
  tempRound: IRound | null;
}

// Define the initial state using that type
const initialState: RoundState = {
  round: null,
  tempRound: null,
};

export const roundSlice = createSlice({
  name: 'round',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setRound: (state, action: PayloadAction<IRoundGame>) => {
      state.round = action.payload;
    },

    updateRound(state, action: PayloadAction<Partial<IRoundGame>>) {
      if (state.round) {
        state.round = { ...state.round, ...action.payload };
      }
    },

    setNullRound: (state) => {
      state.round = null;
    },

    setTempRound: (state, action: PayloadAction<IRound>) => {
      state.tempRound = action.payload;
    },

    setNullTempRound: (state) => {
      state.tempRound = null;
    },
  },
});

export const {
  setRound,
  updateRound,
  setNullRound,
  setTempRound,
  setNullTempRound,
} = roundSlice.actions;

export default roundSlice.reducer;
